import { epBuilderAnyIssuer } from "@app/statefx/routines/mapperfn-pathbuilder";
import { TBlueTable } from "@app/types/insider";

import type {
  TRepoSPVMessages,
  TSPVMessageKeys,
  TSPVInvoiceRaw,
  TSPVUState,
} from "@app/types/insider";

/* 
CREATE TABLE FXML_MESSAGE_KEYS (
  FMK_ID INTEGER NOT NULL,
  FXM_ID INTEGER NOT NULL,
  CFF_ID INTEGER,
  CFFTMP_ID INTEGER,
  CLI_FF_ID INTEGER,
  FZ_F_ID INTEGER,
  PARSE_ATTEMPTS INTEGER,
  UPDATED TIMESTAMP);
*/

export const SPVMessages: TBlueTable<TRepoSPVMessages> = {
  name: "SPVMessages",
  empty: {} as TRepoSPVMessages,
  initialState: {},
  primaryKey: "FXM_ID",
  apiUrl: "/select/ss_spv_messages_range",
  pkeyUrl: "/select/ss_spv_messages_range_pkey",
  urlPathBuilder: epBuilderAnyIssuer, //epBuilderAll
  starfx: true,
  starfx_index: "FXM_ID",
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "byCreationDate", keyPath: "QDATA_CREARE" },
    { name: "byIssuerCIF", keyPath: "QMY_CIF" },
    {
      name: "byCreationDateAndIssuerCIF",
      keyPath: ["QDATA_CREARE", "QMY_CIF"],
    },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  bootPriority: 2,
  onmru: "new",
  oncsdb: "full",
  label: "Mesaje SPV",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const SPVMessageKeys: TBlueTable<TSPVMessageKeys> = {
  name: "SPVMessageKeys",
  empty: {} as TSPVMessageKeys,
  initialState: {},
  primaryKey: "FMK_ID",
  apiUrl: "/select/ss_message_keys_range",
  pkeyUrl: "/select/ss_message_keys_range_pkey",
  urlPathBuilder: epBuilderAnyIssuer,
  starfx: true,
  starfx_index: "FMK_ID",
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "msgkeyByFXMCreData", keyPath: "FXM_QDATA" },
    { name: "msgkeyByIssuerCIF", keyPath: "FXM_QMYCIF" },
    { name: "msgkeyByFXMID", keyPath: "FXM_ID" },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  bootPriority: 2,
  onmru: "new",
  oncsdb: "full",
  label: "Mesaje SPV",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const SPVInvoiceRaw: TBlueTable<TSPVInvoiceRaw> = {
  name: "SPVInvoiceRaw",
  empty: {} as TSPVInvoiceRaw,
  initialState: {},
  apiUrl: "/select/ss_msgbodyraw",
  pkeyUrl: "/select/ss_msgbodyraw_pkey",
  primaryKey: "FRAW_ID",
  urlPathBuilder: epBuilderAnyIssuer,
  starfx: true,
  starfx_index: "FRAW_ID",
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "bodyByFXMCreData", keyPath: "FXM_QDATA" },
    { name: "bodyByIssuerCIF", keyPath: "FXM_QMYCIF" },
    { name: "bodyByFMXID", keyPath: "FXM_ID" },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  bootPriority: 2,
  onmru: "new",
  oncsdb: "full",
  label: "Mesaje SPV - continut",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const SPVMessageUserState: TBlueTable<TSPVUState> = {
  name: "SPVMessageUserState",
  empty: {} as TSPVUState,
  initialState: {},
  primaryKey: "FMUS_ID",
  apiUrl: "/select/ss_xml_userstat_srange",
  pkeyUrl: "/select/ss_xml_userstat_srange_pkey",
  urlPathBuilder: epBuilderAnyIssuer,
  starfx: true,
  starfx_index: "FMUS_ID",
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "ustatByFXMCreData", keyPath: "FXM_QDATA" },
    { name: "ustatByIssuerCIF", keyPath: "QMY_CIF" },
    {
      name: "ustatByFXMCreDataAndIssuerCIF",
      keyPath: ["FXM_QDATA", "QMY_CIF"],
    },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  bootPriority: 2,
  onmru: "new",
  oncsdb: "full",
  label: "Mesaje SPV - adnotari",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};
